import { useBoxStyle } from "arkh";
import React from "react";
import {
  NavigationContainer,
  NavigationIndependentTree,
} from "@react-navigation/native";
import { ActionSheetProvider } from "@expo/react-native-action-sheet";
import { PreloadedQuery } from "react-relay";
import { TodoBottomSheetStack } from "./TodoBottomSheetStack";

import { TodoBottomSheetMainScreenQuery } from "./__generated__/TodoBottomSheetMainScreenQuery.graphql";
import { TodoBottomSheetMain } from "./TodoBottomSheetMain";
import { TodoBottomSheetNavigatorContext } from "./TodoBottomSheetNavigatorContext";
import { getTodoBottomSheetScreenOptions } from "./getTodoBottomSheetScreenOptions";
import { TodoBottomSheetLinkProduct } from "./TodoBottomSheetLinkProduct";

export function TodoBottomSheetContent(props: {
  todoId: string;
  mainQuery: PreloadedQuery<TodoBottomSheetMainScreenQuery>;
  mode: "edit" | "create";
  openTodoMoveToCategory: (todoId: string) => void;
  onShowFile(id: string): void;
  openProductDetail(productId: string): void;
}) {
  return (
    <ActionSheetProvider>
      <TodoBottomSheetNavigatorContext.Provider
        value={{
          openTodoMoveToCategory: props.openTodoMoveToCategory,
          onShowFile: props.onShowFile,
          openProductDetail: props.openProductDetail,
        }}
      >
        <NavigationIndependentTree>
          <NavigationContainer
            documentTitle={{
              enabled: false,
            }}
            key={props.todoId}
          >
            <TodoBottomSheetStack.Navigator
              initialRouteName="main"
              screenOptions={{
                contentStyle: useBoxStyle({
                  color: "surface-primary",
                }),
              }}
            >
              <TodoBottomSheetStack.Screen
                name="main"
                component={TodoBottomSheetMain}
                options={({ navigation }) =>
                  getTodoBottomSheetScreenOptions({
                    title: "",
                    headerLeft: "DONE",
                    navigation,
                  })
                }
                initialParams={{
                  todoId: props.todoId,
                  mode: props.mode,
                  query: props.mainQuery,
                }}
              />

              <TodoBottomSheetStack.Screen
                name="linkProduct"
                component={TodoBottomSheetLinkProduct}
                options={({ navigation }) =>
                  getTodoBottomSheetScreenOptions({
                    title: "",
                    headerLeft: "BACK",
                    navigation,
                  })
                }
              />
            </TodoBottomSheetStack.Navigator>
          </NavigationContainer>
        </NavigationIndependentTree>
      </TodoBottomSheetNavigatorContext.Provider>
    </ActionSheetProvider>
  );
}
